import { useNavigate, useParams } from "react-router-dom"
import usePages from "../hooks/usePages"
import { useReducerAsState } from "../hooks/useReducerAsState"
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { pageSchema } from "../schemas/pages.schema";
import { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { Button, Card, Label, Select, TextInput } from "flowbite-react";
import { Wysiwyg } from "../components";
import { routes } from "../routes";

interface State {
    description: string;
}

const PageDetailsScreen = () => {
    const { id } = useParams()
    const { loading,  fetchPage, savePage } = usePages()
    const editorRef = useRef<any>(null);

    const navigate = useNavigate()

    const [state, setState] = useReducerAsState<State>({
        description:"",
    })

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
      resolver: yupResolver(pageSchema),
    });

    const fetchPageDetails = async (id: number) => {
        const details = await fetchPage(id)
        if(!details) return
        setState({ 
            description: details.description,
        })

        setValue("title", details.title)
        setValue("published", details.published)
    }

    const save = async (data: any) => {
        try {
            if (editorRef && editorRef.current) {
                const content = editorRef.current.getContent()
                if(content.length === 0){
                    toast("No olvides escribir el contenido de la página",{
                        type: "warning"
                    })
                    return
                }

                const info = {
                    id: id ? parseInt(id) : undefined,
                    title: data.title as string,
                    description: content as string,
                    published: data.published as number,
                }
        
                const saved = await savePage(info)
                toast(saved ? "Página guardada correctamente." : "Ocurrió un error al guardar la página.",{
                    type: saved ? "success" : "error"
                });

                if(saved && isNaN(parseInt(id!))){
                    navigate(`${routes.DASHBOARD}/${routes.PAGES}`, {
                        replace: true
                    })
                }
            }
        } catch(e){
            console.log(e,'ERROR_FORM')
        }
    };

    const initialize = async () => {
        if(!id) return

        const itemId = parseInt(id)
        if(!isNaN(itemId)){
           await fetchPageDetails(itemId)
        }
    }

    useEffect(() => {
        initialize();
        // eslint-disable-next-line
    },[])

    return <div className="m-4">
        <div className="mb-4">
            <div className="flex flex-row justify-between">
                <h1>Detalles de la página</h1>
                <Button isProcessing={loading} disabled={loading} onClick={handleSubmit(save)}>Guardar página</Button>
            </div>
        </div>
        <Card>
            <div className="flex flex-col mb-2">
                <Label className="mb-2">Título</Label>
                <TextInput 
                    placeholder="Escriba aquí"
                    {...register("title")}
                    helperText={errors && errors.title ? errors.title.message : ""}
                    required 
                    color={errors && errors.title ? "failure" : "gray"}
                />
            </div>
            
            <div className="flex flex-row mb-0 items-start justify-between gap-4">
                <div className="flex flex-col max-w-md flex-1">
                    <div className="mb-2 block">
                        <Label htmlFor="published" value="Publicada" />
                    </div>
                    <Select 
                        id="published"
                        required 
                        {...register("published")}
                        helperText={errors && errors.published ? errors.published.message : ""}
                        color={errors && errors.published ? "failure" : "gray"}
                    >
                        <option value="-1">- Elija una opción -</option>
                        <option value="1">Si</option>
                        <option value="0">No</option>
                    </Select>   
                </div>
            </div>
            
            <Wysiwyg 
                label={'Descripción'}
                editorRef={editorRef}
                content={state.description || ""}
            />
        </Card>
    </div>
}

export default PageDetailsScreen